import { PureComponent } from 'react'
import styled from 'glamorous'
import { Loader } from 'components'
import { $ } from 'utils'

const disabledStyles = {
  pointerEvents: 'none',
  opacity: '.3 !important'
}

const Container = styled.div({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6px 12px',
  marginBottom: 0,
  fontSize: 14,
  textAlign: 'center',
  whiteSpace: 'nowrap',
  verticalAlign: 'middle',
  cursor: 'pointer',
  userSelect: 'none',
  border: '1px solid var(--violet)',
  borderRadius: 4
}, ({
      width,
      height,
      primary,
      bgColor,
      isDisabled
    }) => ({
  width, height,
  color: bgColor,
  borderColor: bgColor,
  ...(isDisabled && disabledStyles),
  ...(!primary && {
    '&:hover': {
      backgroundColor: bgColor,
      color: 'white',
    }
  }),
  ...(primary && {
    color: 'white',
    backgroundColor: bgColor,
    '&:hover': {
      opacity: .8
    },
  })
}))

Container.button = Container.withComponent('button')
Container.span = Container.withComponent('span')

class Button extends PureComponent {
  state = {
    isLoading: this.props.isLoading
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ isLoading: nextProps.isLoading })
  }

  reset = () => {
    this.setState({ isLoading: false })
  }

  handleClick = (e) => {
    if (typeof this.props.onClick === 'function') {
      this.setState({ isLoading: true })

      const promise = this.props.onClick()
      if (promise && promise.then !== undefined) {
        promise
          .then(() => this.reset())
          .catch(() => this.reset())
      } else {
        this.reset()
      }
    }
  }

  render() {
    const { isDisabled, tag = 'button', onClick, children, ...props } = this.props
    const { isLoading } = this.state
    return (
      $(Container[tag], {
          isDisabled: isDisabled || isLoading,
          onClick: e => this.handleClick(e),
          ...props
        },
        !isLoading
          ? children
          : $(Loader, { size: 16 })
      )
    )
  }
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button.js